import { configureStore } from '@reduxjs/toolkit';
import { apiService } from '../data/api/endPointsSlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import agentsFiltersReducer from './slices/AgentsFiltersSlice';
import appsFiltersReducer from './slices/AppsFiltersSlice';

export const store = configureStore({
  reducer: {
    agentsFilters: agentsFiltersReducer,
    appsFilters: appsFiltersReducer,
    [apiService.reducerPath]: apiService.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // For handling non-serializable values like FormData
    }).concat(apiService.middleware),
});

// Enable refetchOnFocus and refetchOnReconnect behaviors
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
